function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";

/**
 * Video player for Content Hub clips.
 * Chrome suspends a <video preload="metadata"> that sat in a background tab or offscreen; after that it
 * reports "playing" but the play head never leaves 0:00. Loading on demand avoids the suspended pipeline,
 * and if a play still does not advance within a second the element is reloaded and played again.
 */
export default class ClipPlayer extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ref", /*#__PURE__*/React.createRef());
    _defineProperty(this, "onPlay", () => {
      clearTimeout(this._t);
      this._t = setTimeout(() => {
        const el = this.ref.current;
        if (!el || el.paused || el.ended || el.currentTime > 0.05 || this._recovered) return;
        this._recovered = true;
        const wasMuted = el.muted;
        el.load();
        el.muted = wasMuted;
        el.play().catch(() => {});
      }, 1200);
    });
  }
  componentWillUnmount() {
    clearTimeout(this._t);
  }
  componentDidUpdate(prev) {
    if (prev.src !== this.props.src) this._recovered = false;
  }
  render() {
    const {
      src,
      poster,
      style,
      className
    } = this.props;
    if (!src) return null;
    return /*#__PURE__*/React.createElement("video", {
      ref: this.ref,
      src: src,
      poster: poster || undefined,
      controls: true,
      playsInline: true,
      preload: poster ? "none" : "metadata",
      onPlay: this.onPlay,
      style: style,
      className: className
    });
  }
}